"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var skybetDiffusionName = exports.skybetDiffusionName = window.skybetDiffusionName ? window.skybetDiffusionName.toUpperCase() : "SKYBET_FLUTTER";


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/utils/PreloadedStateHelper.js
// module id = 440
// module chunks = 1